import React, {Component} from 'react';

import SlickSlider from "react-slick";

import NavigationMap from '../NavigationMap'
import IsraelMap from '../IsraelMap'
import WestbankMap from '../WestbankMap'

import './Maps.scss';

export default class Maps extends Component {

    render() {
        const settings = {
            arrows: false,
            dots: true,
            infinite: true,
            speed: 300,
            adaptiveHeight: false,
            slidesToShow: 1,
            slidesToScroll: 1
        };

        return (
            <div className="Maps">
                <SlickSlider {...settings}>
                    <div className="Maps__slide">
                        <div className="Maps__map">
                            <NavigationMap />
                        </div>
                    </div>
                    <div className="Maps__slide">
                        <div className="Maps__map">
                            <WestbankMap />
                        </div>
                    </div>
                    <div className="Maps__slide">
                        <div className="Maps__map">
                            <IsraelMap />
                        </div>
                    </div>
                </SlickSlider>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Navigation/Maps/index.js